import React from "react";
import "./Home.css";

function BugNet() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>Bug Net</h1>
            <p className="home-subtitle">
              <img className="brandImg" src="/bugWall.webp" />
              <br />RAM Promaster Side Sliding Door Insect Screen
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/12dhMf_ZIqv-y5t_b9T6ScJbDWk4jxzPq/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          Unclip the net from the top. Zip the side panels closed.
        </p>
        <p className="tealText">
          Enter and exit the van through the magnetized section in the middle.
        </p>
      </div>

      <div className="movCont">
        <img
          src="/bugNet.jpg?v=${new Date().getTime()}"
          className="home-image"
        />
      </div>
    </div>
  );
}

export default BugNet;
